import React from 'react';
import ABSHref from '../ABSHref';
import { HEYI_TELEPHONE, HEYI_MAIL } from '../../utils/constant';
import { IHrefTpye } from './util';

export interface IABSResolvePhoneOrMailProps {
  type?: 'tel' | 'mail';
}
 
export interface IABSResolvePhoneOrMailState {
  
}
 
class ABSResolvePhoneOrMail extends React.Component<IABSResolvePhoneOrMailProps, IABSResolvePhoneOrMailState> {
  static defaultProps = {
    type: IHrefTpye.tel,
  };

  render() { 
    const { type } = this.props;
    const phonesOrMails = type === IHrefTpye.tel ? HEYI_TELEPHONE.split('/') : HEYI_MAIL.split('/');
    let content;
    if (phonesOrMails && Array.isArray(phonesOrMails)) {
      const hrefType = type === IHrefTpye.tel ? type : type + 'to';
      content = phonesOrMails.map((item, index) => {
        if (index !== phonesOrMails.length - 1) {
          return (
            <>
              <ABSHref key={item} href={hrefType + ':' + item.replace(/\s/g, '')}>{item}</ABSHref>
              <span> / </span>
            </>
          );
        }
        return <ABSHref key={item} href={hrefType + ':' + item.replace(/\s/g, '')}>{item}</ABSHref>;
      });
    }
    return content;
  }
}
 
export default ABSResolvePhoneOrMail;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSResolvePhoneOrMail/index.tsx